import * as actionTypes from '@actions/actionTypes';

export const initialState = {
    validatingAuth: false,
    loggedIn: false,
    shouldRedirect: false,
    errorMessage: null,
    sessionEnd: false,
};

const security = (state = initialState, action = null) => {
    switch (action.type) {
        case actionTypes.AUTHENTICATION_CHECK: {
            return {
                ...state,
                validatingAuth: true,
            };
        }
        case actionTypes.AUTHENTICATION_SUCCESS: {
            return {
                ...state,
                validatingAuth: false,
                loggedIn: true,
                shouldRedirect: false,
            };
        }
        case actionTypes.AUTHENTICATION_FAILURE: {
            return {
                ...state,
                validatingAuth: true,
                loggedIn: false,
                shouldRedirect: true,
            };
        }
        case actionTypes.FETCH_AUTHENTICATION_FAILURE: {
            return {
                ...state,
                errorMessage: action.errorMessage,
                validatingAuth: false,
                loggedIn: false,
                shouldRedirect: false,
            };
        }
        case actionTypes.SESSION_END: {
            return {
                ...state,
                sessionEnd: true,
            };
        }
        case actionTypes.SAVE_USER: {
            const privileges = Object.values(action.data.resources || {})
                .filter((resource) => 'object' === typeof resource)
                .reduce((acc, resource) => {
                    acc[parseInt(resource.id, 10)] = resource.privileges;

                    return acc;
                }, {});

            return {
                ...state,
                user: {
                    privileges,
                    name: action.data.name,
                    id: action.data.id,
                },
            };
        }
        case actionTypes.REDIRECT_TO_AUTH_LOGIN: {
            !action.test && window.location.replace(action.fromUrl);

            return initialState;
        }

        default:
            return state;
    }
};

export default security;
